import React, { useRef } from "react";
import { Tooltip } from "flowbite-react";

interface TruncatedNameWithTooltipProps {
  name: string;
  widthClass?: string; // Tailwind width class (e.g., w-32, w-[150px])
  textClass?: string; // Optional text styling override
  tooltipClass?: string; // Optional class for tooltip
  tooltip?: boolean; // Whether to show tooltip or not
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  arrow?: boolean; // Optional prop to control arrow visibility
}

const TruncatedNameWithTooltip: React.FC<TruncatedNameWithTooltipProps> = ({
  name,
  widthClass = "w-32",
  textClass = "text-sm text-gray-800",
  tooltip = true,
  tooltipPlacement = "bottom",
  arrow = false,
  tooltipClass,
}) => {
  const textRef = useRef<HTMLDivElement>(null);

  const textElement = (
    <div
      ref={textRef}
      className={`line-clamp-1 text-ellipsis cursor-pointer ${widthClass} ${textClass} `}
    >
      {name}
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip
        content={name}
        placement={tooltipPlacement}
        arrow={arrow}
        className={`whitespace-pre-line ${tooltipClass}`}
      >
        <div
          className={`line-clamp-1 text-ellipsis ${widthClass} ${textClass} cursor-pointer `}
        >
          {name}
        </div>
      </Tooltip>
    );
  }

  return textElement;
};

export default TruncatedNameWithTooltip;
